// import firebase from "firebase/app";
import "firebase/firestore";
import { mapGetters } from "vuex";
// import short from "@/data/forms/mixins/short.js";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import afterSearch from "@/data/search/mixins/afterSearch.js";
import announcements from "@/frame/messages/mixins/announcements.js";

export default {
  mixins: [dataSources, afterSearch, announcements],
  data() {
    return {
      results: [],
      totalFound: 0,
      totalSearched: 0,
      indexCounter: 0,
      searchUserLimit: 1000
    };
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters(["getDataSource"])
  },
  methods: {
    checkPreviousResultNoDuplicate(u) {
      // u = did
      let duplicate = false;
      if (this.results.length == 0) {
        // console.log("FIRST RESULT");
        duplicate = true;
      } else {
        console.log("CHECK DUP.");
        console.log("ID Searched " + u.basic.id);
        console.log("ID Previous" + this.results[this.results.length - 1].id);
        if (u.basic.did !== this.results[this.results.length - 1].basic.did) {
          duplicate = true;
        }
      }
      return duplicate;
    },
    resetDataForSearch() {
      this.totalFound = 0;
      this.totalSearched = 0;
      this.results = [];
    },
    searchUsers(search) {
      this.results = []; // reset search
      // Reset Data to begin search
      this.resetDataForSearch();
      // Search Criteria Mode
      let dbs = search.dbs;
      let title = search.title.toLowerCase();
      let status = search.status;
      let licence = search.licence;

      console.log("SEARCH USER");
      console.log(search);

      // search item convet to lower case
      // eslint-disable-next-line
      dbs.orderBy("basic.idg").limit(this.searchUserLimit).get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            // eslint-disable-next-line
            let docData = doc.data();
            let dbStatus = doc.data().basic.act;
            let dbLicence = doc.data().basic.rlic;
            let dbTitle = doc.data().basic.title.toLowerCase();
            // Search
            // CASE 1 Status Only
            if (search.title === "") {
              if (dbStatus === status) {
                if (this.checkPreviousResultNoDuplicate(docData)) {
                  let obj = Object.assign({}, docData);
                  this.appendSearchResult(obj);
                }
              }
              // CASE 2 Status
              // eslint-disable-next-line
            } else if (search.status === null && search.licence === "") {
              if (dbTitle.includes(title)) {
                if (this.checkPreviousResultNoDuplicate(docData)) {
                  let obj = Object.assign({}, docData);
                  console.log("HERE");
                  this.appendSearchResult(obj);
                }
              }
              // CASE 2 Status
              // eslint-disable-next-line
            } else if (search.status !== null && search.licence === "") {
              if (dbStatus === status && dbTitle.includes(title)) {
                if (this.checkPreviousResultNoDuplicate(docData)) {
                  let obj = Object.assign({}, docData);
                  this.appendSearchResult(obj);
                }
              }
              // CASE 4 Licence only
              // eslint-disable-next-line
            } else if (search.status === null && search.licence !== "") {
              if (dbLicence.includes(licence) && dbTitle.includes(title)) {
                if (this.checkPreviousResultNoDuplicate(docData)) {
                  let obj = Object.assign({}, docData);
                  this.appendSearchResult(obj);
                }
              }
              // CASE 2 Licence only
              // eslint-disable-next-line
            } else if (search.status !== null && search.licence !== "") {
              if (
                dbStatus === status &&
                dbTitle.includes(title) &&
                dbLicence.includes(licence)
              ) {
                if (this.checkPreviousResultNoDuplicate(docData)) {
                  let obj = Object.assign({}, docData);
                  this.appendSearchResult(obj);
                }
              }
              // CASE 2 Licence only
              // eslint-disable-next-line
            }
            // CASE 3 NAME and ID
            this.totalSearched++;
          });
        })
        // eslint-disable-next-line
        .then(doc=> {
          this.$store.dispatch("changeSearchResults", this.results);
          console.log(this.results);
          // this is store update and router
          this.doAfterSearching(this.results);
          if (this.results.length === 0) {
            this.generateInfoSnackbar("wplorange0", "No records found.");
            this.enableSpinBtnSearch = false;
          }
        });
    },
    appendSearchResult(searchResult) {
      let obj = searchResult;
      this.results.push(obj);
    }
  }
};
